export default function inputRefValue(ref: React.RefObject<HTMLInputElement>) {
  return (ref.current && ref.current.value) || ''
}
